export const TagVariants = {
  CHIP: 'CHIP', // aka filter
  MAIN: 'MAIN', // aka info
  PRIMARY: 'PRIMARY', // aka card
  NAKED: 'NAKED' // generic usage to benefit of showing x out of y and (+ more behavior)
};

export const TagStatus = {
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  ERROR: 'ERROR'
};
